import { closedReason } from '../../../lib/eventJourney';
import { attendanceText, rsvpText } from './GuestsList';

// A leading = + - @ (or tab/CR) would be run as a formula by Excel/Sheets: a guest can register as `=HYPERLINK(...)`
// through the public form, so such cells get an apostrophe (as List Management's export does).
const cell = (value) => {
    let text = String(value ?? '');
    if (/^[=+\-@\t\r]/.test(text)) text = `'${text}`;
    return /[",\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

/**
 * The Guests list as CSV (P9, moved here from the Attendees tab). Rows are joined with a REAL newline: the
 * old export joined them with the two characters backslash-n, so a spreadsheet read one very long row.
 */
export function guestsCsv(cards, { columns, columnOf, phase }) {
    const header = ['Name', 'Email', 'Company', 'Title', 'Stage', 'RSVP', 'Attendance', 'Contact Owner', 'Source'];
    const rows = cards.map((card) => {
        const key = columnOf(card);
        const column = columns.find((item) => item.key === key);
        return [
            card.name, card.email, card.company, card.title,
            key === 'closed' ? `Closed · ${closedReason(card)}` : (column?.label || key),
            rsvpText(card, key), attendanceText(card, phase), card.owner_name, card.source,
        ];
    });
    return [header, ...rows].map((row) => row.map(cell).join(',')).join('\n');
}

/** Hand the CSV to the browser as a download. */
export function downloadCsv(text, filename) {
    const url = URL.createObjectURL(new Blob([`\uFEFF${text}`], { type: 'text/csv;charset=utf-8' }));
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
}
